import React from 'react'
import {
  AlignItems,
  Box,
  Color,
  Display,
  Divider,
  FlexDirection,
  Icon,
  IconVariant,
  JustifyContent,
  Text,
  FontWeight,
} from '@gousto-internal/citrus-react'

const recipeTitleWidths = ['48%', '70%', '42%', '62%', '54%']

const LoadingSkeleton = ({ height = '18px', width }: { height?: string; width: string }) => (
  <Box
    bg={Color.ColdGrey_100}
    borderRadius={1}
    width={width}
    height={height}
    data-testid="loading-skeleton"
    aria-hidden="true"
  />
)

const RecipeRowPlaceholder = ({ titleWidth }: { titleWidth: string }) => (
  <Box
    display={Display.Flex}
    justifyContent={JustifyContent.SpaceBetween}
    gap={4}
    data-testid="order-summary-placeholder-recipe-row"
  >
    <Box
      display={Display.Flex}
      flexDirection={FlexDirection.Column}
      gap={1}
      minWidth="0"
      style={{ width: '72%' }}
    >
      <LoadingSkeleton width={titleWidth} height="24px" />
      <LoadingSkeleton width="44%" />
    </Box>
    <Box display={Display.Flex} justifyContent={JustifyContent.FlexEnd} style={{ width: '18%' }}>
      <LoadingSkeleton width="82px" height="24px" />
    </Box>
  </Box>
)

export const OrderSummaryPlaceholder = ({ recipeCount }: { recipeCount: number }) => (
  <Box
    bg={Color.White}
    borderRadius={1.5}
    boxShadow="0 1px 6px rgba(0, 0, 0, 0.12)"
    paddingH={4}
    paddingV={4}
    color={Color.ColdGrey_900}
    style={{ borderRadius: '6px' }}
    data-testid="order-summary-placeholder"
    aria-label="Order prices are updating"
    role="status"
  >
    <Box display={Display.Flex} alignItems={AlignItems.Center} gap={2}>
      <Icon name="payment" variant={IconVariant.Default} size={5} />
      <Text fontWeight={FontWeight.Bold}>Order total</Text>
    </Box>

    <Box
      display={Display.Flex}
      flexDirection={FlexDirection.Column}
      gap={3}
      style={{ paddingTop: '0.5rem' }}
    >
      <LoadingSkeleton width="58%" />
      {Array.from({ length: recipeCount }, (_, index) => (
        <RecipeRowPlaceholder
          key={`recipe-row-${index}`}
          titleWidth={recipeTitleWidths[index % recipeTitleWidths.length]}
        />
      ))}
      <Divider />
      <Box display={Display.Flex} justifyContent={JustifyContent.SpaceBetween} gap={4}>
        <LoadingSkeleton width="20%" height="24px" />
        <LoadingSkeleton width="64px" height="24px" />
      </Box>
    </Box>

    <Box paddingBottom={0} paddingV={2}>
      <Divider />
      <Box display={Display.Flex} justifyContent={JustifyContent.SpaceBetween} paddingV={2}>
        <LoadingSkeleton width="14%" height="24px" />
        <Box display={Display.Flex} gap={2}>
          <LoadingSkeleton width="58px" height="24px" />
          <LoadingSkeleton width="72px" height="24px" />
        </Box>
      </Box>
    </Box>
  </Box>
)
